package com.evoapps.evoshift.ui.util

/** Test tags of controls the interaction tests (composeApp/src/androidHostTest) press. */
object TestTags {
    // Onboarding (SH-38)
    const val ONBOARDING_BACK = "onboarding_back"
    const val ONBOARDING_SIGN_OUT = "onboarding_sign_out"
    const val ONBOARDING_PROGRESS = "onboarding_progress"
    const val ONBOARDING_START = "onboarding_start"
    const val ONBOARDING_ROLE_OWNER = "onboarding_role_owner"
    const val ONBOARDING_ROLE_JOIN = "onboarding_role_join"
    const val ONBOARDING_BUSINESS_NAME = "onboarding_business_name"
    const val ONBOARDING_WORKPLACE_NAME = "onboarding_workplace_name"
    const val ONBOARDING_NEXT = "onboarding_next"
    const val ONBOARDING_SKIP = "onboarding_skip"
    const val ONBOARDING_OPENS_EARLIER = "onboarding_opens_earlier"
    const val ONBOARDING_OPENS_LATER = "onboarding_opens_later"
    const val ONBOARDING_CLOSES_EARLIER = "onboarding_closes_earlier"
    const val ONBOARDING_CLOSES_LATER = "onboarding_closes_later"
    const val ONBOARDING_INVITE_CODE = "onboarding_invite_code"
    const val ONBOARDING_JOIN = "onboarding_join"
    const val ONBOARDING_FINISH = "onboarding_finish"
    const val ONBOARDING_FINANCE_YES = "onboarding_finance_yes"
    const val ONBOARDING_FINANCE_NO = "onboarding_finance_no"
    const val ONBOARDING_REVIEW_DEFAULTS = "onboarding_review_defaults"
    const val ONBOARDING_EDIT_OPEN_DAYS = "onboarding_edit_open_days"
    const val ONBOARDING_REVIEW_WORKPLACE = "onboarding_review_workplace"
    const val ONBOARDING_EDIT_NAME = "onboarding_edit_name"
    const val ONBOARDING_EDIT_SALES_TARGETS = "onboarding_edit_sales_targets"
    /** The pencil of the [index]th starter shift / availability slot on the review (SH-62). */
    fun onboardingEditShift(index: Int) = "onboarding_edit_shift_$index"
    fun onboardingEditSlot(index: Int) = "onboarding_edit_slot_$index"
    fun day(isoDay: Int) = "onboarding_day_$isoDay"

    // Plans (SH-38)
    const val PAYWALL_SUBSCRIBE = "paywall_subscribe"
    const val PAYWALL_CHANGE_NOTICE = "paywall_change_notice"
    const val PAYWALL_RESTORE = "paywall_restore"
    const val PAYWALL_SECONDARY = "paywall_secondary"
    const val PAYWALL_RETRY = "paywall_retry"
    /** SH-220: "Other plans", the larger-team contact, the recommended label and the over-plan notice. */
    const val PAYWALL_OTHER_PLANS = "paywall_other_plans"
    const val PAYWALL_CONTACT = "paywall_contact"
    const val PAYWALL_RECOMMENDED = "paywall_recommended"
    const val PAYWALL_OVER_PLAN = "paywall_over_plan"
    const val OVER_PLAN_BANNER = "over_plan_banner"
    const val OVER_PLAN_UPGRADE = "over_plan_upgrade"
    const val OVER_PLAN_LATER = "over_plan_later"
    fun offer(packageId: String) = "paywall_offer_$packageId"
    fun seatTier(seats: Int) = "paywall_seats_$seats"

    // Read-only after the plan ended (SH-65)
    const val PLAN_ENDED_BANNER = "plan_ended_banner"

    // SH-147: people working without pay terms
    const val MISSING_PAY_BANNER = "missing_pay_banner"
}
